import { Component, Input, OnInit } from '@angular/core';
import { UserApiService } from '../../services/user-api.service';
import { UserProfile } from '../../models/user-profile';
import { DatePipe } from '@angular/common';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { LoggerService } from 'src/app/services/logger.service';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: '<user-link>',
  templateUrl: './user-link.component.html',
  styleUrls: ['./user-link.component.css'],
  providers: [DatePipe],
})
export class UserLinkComponent {
  public isDarkMode: boolean;
  constructor(
    public logger: LoggerService,
    public apiService: UserApiService,
    public datePipe: DatePipe,
    private cookieService: CookieService
  ) {
    this.thisUser = new UserProfile();
    this.thisUser.imageurl = '../../assets/img/avatars/no-image.png';
    this.isRTL = true;

    if (document.getElementsByClassName('dark-style').length > 0) {
      this.isDarkMode = true;
    } else {
      this.isDarkMode = false;
    }

  }
  @Input() thisUser: UserProfile;
  public userProfile: string = `userprofile`;
  public helpCenter: string = `helpCenter`;
  public loading: boolean = true;

  public isRTL: boolean;

  public ngOnInit(): void {

    var cultureCookieValue = this.cookieService.get('Culture');
    if (cultureCookieValue == '') {
      this.cookieService.set('Culture', 'fa-IR');
      cultureCookieValue = 'fa-IR';
    }

    if (cultureCookieValue == 'fa-IR') {
      this.isRTL = true;
    } else {
      this.isRTL = false;
    }
  }

  public changeMode() {
    let html = document.getElementsByTagName('html')[0]

    if (this.isDarkMode) {
      html.classList.remove('light-style');
      html.classList.add('dark-style');
    } else {
      html.classList.add('light-style');
      html.classList.remove('dark-style');
    }

    this.isDarkMode = !this.isDarkMode;
  }
}
